export function debugValue<T>(value: T, name: string): void {
  if (
    window.location.href.includes('localhost:3000') ||
    window.location.href.includes('friendly-hermann-eceb82')
  ) {
    (window['ytd'][name] as any) = value;
  }
}
